var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "  icon_alert_fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "  Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0.8C5 0.8 0.8 5 0.8 10 0.8 15 5 19.2 10 19.2 15 19.2 19.2 15 19.2 10 19.2 5 15 0.8 10 0.8L10 0.8ZM10.5 15.5C10.5 15.8 10.3 16 10 16 9.7 16 9.5 15.8 9.5 15.5L9.5 13.9C9.5 13.6 9.7 13.4 10 13.4 10.3 13.4 10.5 13.6 10.5 13.9L10.5 15.5 10.5 15.5ZM10.5 11.5C10.5 11.7 10.3 12 10 12 9.7 12 9.5 11.8 9.5 11.5L9.5 4.5C9.5 4.2 9.7 4 10 4 10.3 4 10.5 4.2 10.5 4.5L10.5 11.5 10.5 11.5Z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2c90cb25788ddb38372a8a2369602434.svg";
export { ForwardRef as ReactComponent };